module.exports = __webpack_public_path__ + "static/media/tShirt.71360344.jpg";